import React, { useEffect, useState, useRef } from "react";
import "./Home.css";
import Images from "../../Assets/Images/Index";
import Header from "../Header/Header";
import Footer from "../Footer/Footer"; import axios from "axios";
import {
  CircleCheckBig,
  Facebook,
  Play,
  X,
  Plus,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";

function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const [businessCount, setBusinessCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const counterRef = useRef(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [templates, setTemplates] = useState([]);
  const fetchTemplates = async () => {
    try {
      const response = await axios.get(
        "https://qflyers.minipossystem.com/api/v1/register-data"
      );
      console.log({ templates: response.data.templates });
      setTemplates(response.data.templates || []);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const steps = [
    {
      id: 1,
      img: Images.centercardimg1,
      title: "Signup",
      description:
        "Provide some basic information such as your address and montage information.",
    },
    {
      id: 2,
      img: Images.centercardimg2,
      title: "Setup Menu",
      description:
        "Easily add, edit, or remove items from your menu as per your needs.",
    },
    {
      id: 3,
      img: Images.centercardimg3,
      title: "Start Selling",
      description:
        "Begin accepting orders and managing your business efficiently.",
    },
    {
      id: 4,
      img: Images.centercardimg4,
      title: "Manage Orders",
      description:
        "Keep track of customer orders, payments, and deliveries in real time.",
    },
  ];
  const faqs = [
    {
      id: 1,
      question: "Alright, but what exactly do you do?",
      answer:
        "As a creative agency, we work with you to develop solutions to address your brand needs. That includes various aspects of brand planning and strategy, marketing, and design.",
    },
    {
      id: 2,
      question: "What services does Q-Flyers provide?",
      answer:
        "Q-Flyers offers a Digital Menu Card SaaS, a cloud-based platform that helps restaurants, cafes, and food establishments create, manage, and display digital menus for their customers.",
    },
    {
      id: 3,
      question: "How does Q-Flyers help businesses?",
      answer:
        "Q-Flyers simplifies business operations by replacing traditional paper menus with digital menu solutions, allowing businesses to update their menus in real time and enhance customer experience.",
    },
    {
      id: 4,
      question: "Who can benefit from Q-Flyers?",
      answer:
        "Any food-related business, including restaurants, cafes, food trucks, and hotels, can benefit from Q-Flyers. Our platform is scalable and user-friendly for businesses of all sizes.",
    },
    {
      id: 5,
      question: "Why choose Q-Flyers over traditional menus?",
      answer:
        "Q-Flyers offers a more efficient, eco-friendly, and engaging way to present menus. With instant updates, customizable designs, and cloud-based access, businesses can improve their service and attract more customers.",
    },
  ];

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let startBusiness = 0;
          let startCustomer = 0;
          const endBusiness = 40;
          const endCustomer = 25;

          const duration = 2000;
          const interval = 30;
          const stepBusiness = endBusiness / (duration / interval);
          const stepCustomer = endCustomer / (duration / interval);

          const counterInterval = setInterval(() => {
            startBusiness += stepBusiness;
            startCustomer += stepCustomer;

            if (startBusiness >= endBusiness && startCustomer >= endCustomer) {
              setBusinessCount(endBusiness);
              setCustomerCount(endCustomer);
              clearInterval(counterInterval);
            } else {
              setBusinessCount(Math.floor(startBusiness));
              setCustomerCount(Math.floor(startCustomer));
            }
          }, interval);
        }
      },
      { threshold: 0.5 } // Trigger when 50% is visible
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);
  return (
    <div className="out-layer">
      <div className="top-container">
        <div className="header-cont">
          <Header />
        </div>
        <div className="hero-section">
          <div className="hero-left" data-aos="fade-right">
            <img
              src={Images.qflyersMockup}
              alt="Q-Flyers App"
              className="hero-mockup"
            />
          </div>

          <div className="hero-right" data-aos="fade-left">
            <h1>
              <span className="brand">Q-Flyers</span> Created To Make
              Business Easy
            </h1>
            <p>
              Q-Flyers simplifies business operations with a Digital Menu Card SaaS
              platform that helps restaurants, cafes, and other establishments go
              digital in seconds. Create, manage, and serve smart menus — anytime,
              anywhere.
            </p>

            <h3>
              Manage, Serve & Grow <span className="highlight">All in One App.</span>
            </h3>
            <p className="subtext">
              Get the Q-Flyers app from the <strong>Play Store</strong> or{" "}
              <strong>App Store</strong> and bring your business online effortlessly.
            </p>

            <div className="app-buttons">
              <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                <img src={Images.app} alt="App Store" />
                <a href="https://play.google.com/store/apps/details?id=com.qflyers&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                  <img src={Images.play} alt="Google Play" />
                </a>

              </div>

              <div>
                <p className="footer-text">
                  Start your digital journey today with <br /><span>Q-Flyers.</span>
                </p>
              </div>

            </div>


          </div>
        </div>


        <div className="tempalte-container ">
          <div class="lined-heading">
            <h1>Template</h1>
          </div>

          <h2>Our Valuable Template</h2>
          <div className="temp-img-scroll">
            <div className="scroll-container">
              {/* <img src={Images.Template1} alt="Template 1" />
               <img src={Images.Template2} alt="Template 5" />
              <img src={Images.Template3} alt="Template 2" />
              <img src={Images.Template4} alt="Template 3" />
              <img src={Images.Template5} alt="Template 4" />
              <img src={Images.Template6} alt="Template 5" />
              <img src={Images.Template7} alt="Template 6" />
              <img src={Images.Template8} alt="Template 7" />
              <img src={Images.Template9} alt="Template 8" />
              <img src={Images.Template10} alt="Template 9" />
              <img src={Images.Template11} alt="Template 1" />
              <img src={Images.Template12} alt="Template 2" />
              <img src={Images.Template13} alt="Template 3" />
              <img src={Images.Template14} alt="Template 4" />
              <img src={Images.Template15} alt="Template 6" />
              <img src={Images.Template16} alt="Template 7" /> */}
              {templates.map((template, index) => (
                <>
                  <div className="orangebox"></div>
                  <img
                    key={template.id}
                    src={template.image}
                    alt={`Template ${index + 1}`}

                  />
                </>
              ))}
            </div>
          </div>
        </div>
        <div className="linecontainer">

          <div class="lined-heading">
            <h1>View More</h1>
          </div>
        </div>
        <div className="menu-container ">

          <div className="menu-img">
            <img src={Images.menucard} alt="Menu Card" />
          </div>
          <div className="menu-text">
            <h3>Powerful features</h3>
            <h2>Unlock the power of<br /><h1 style={{ color: "#f04b3d" }}>Digital Menu Card!</h1> </h2>
            <span className="description">
              Enhance your experience and enjoy seamless automation, intelligent
              insights, and effortless management. Discover the difference with
              Qflyers.
            </span>

            <div className="feature">
              <div className="d-flex gap-3">
                <CircleCheckBig className="icon" />
                <h4>AI-Driven Content Creation</h4>
              </div>
              <p>
                AI-driven content creation saves time by automating engaging
                posts and marketing strategies. It analyzes trends to optimize
                content, ensuring efficiency and consistency for businesses and
                influencers, while enhancing audience engagement.
              </p>
            </div>

            <div className="feature">
              <div className="d-flex gap-3">
                <CircleCheckBig className="icon" />
                <h4>Smart Scheduling & Automation</h4>
              </div>
              <p>
                Boost engagement with AI-powered scheduling and automation. AI
                analyzes audience activity to recommend the best posting times,
                ensuring maximum reach. Automated publishing keeps content
                consistent, letting you focus on growing your brand.
              </p>
            </div>
          </div>
        </div>
        <div className="values-container">
          <div className="values-container container">
            <div className="values-text">
              <div className="value-text">
                <p>About</p>
                <h1>Our Values</h1>
              </div>

              <p className="description">
                Discover the power of our secure an rewarding credit cards.
              </p>
              <div className="value-black-card" ref={counterRef}>
                <div className="right-card">
                  <h3>
                    <span className="plus-symbol-right">+</span>
                    {businessCount} M
                  </h3>
                  <p>Business</p>
                </div>
                <div className="seperator"></div>
                <div className="left-card">
                  <h3>
                    <span className="plus-symbol-left">+</span>
                    {customerCount} B
                  </h3>
                  <p>Customers</p>
                </div>
              </div>
            </div>
            <div className="facebook-cards">
              <div className="facebook-card">
                <div className="icon-container-circle">
                  <div className="icon-container">
                    <Facebook />
                  </div>
                </div>
                <div className="mt-5">
                  <h6>Facebook</h6>
                  <p>
                    AI-Powered Content Creation - Generate tailored posts,
                    captions, and strategies effortlessly.
                  </p>
                </div>
              </div>
              <div className="facebook-card">
                <div className="instagram-icon-container-circle">
                  <div className="instagram-icon-container">
                    <Instagram />
                  </div></div>
                <div className="mt-5">
                  <h6>Instagram</h6>
                  <p>
                    AI-Powered Content Creation - Generate tailored posts,
                    captions, and strategies effortlessly.
                  </p>
                </div>
              </div>
              <div className="facebook-card">
                <div className="linkedin-icon-container-circle">
                  <div className="linkedin-icon-container">
                    <Linkedin />
                  </div>
                </div>
                <div className="mb-5">
                  <h6>LinkedIn</h6>
                  <p>
                    AI-Powered Content Creation - Generate tailored posts,
                    captions, and strategies effortlessly.
                  </p>
                </div>
              </div>
              <div className="facebook-card">
                <div className="twitter-icon-container-circle">
                  {/* <div className="twitter-icon-container-empty"></div> */}
                  <div className="twitter-icon-container">
                    <Twitter />
                  </div>
                </div>

                <h6>Twitter</h6>
                <p>
                  AI-Powered Content Creation - Generate tailored posts, captions,
                  and strategies effortlessly.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="works-container">
          <div className="center-container container">
            <div className="image-wrapper">
              <img
                src={Images.centercard}
                alt="How It Works"
                className="center-image"
              />
              <div className="centered">
                <p>How it</p>
                <h2>Works</h2>
                <p className="centered-p">
                  Allow businesses to easily update items, prices, and
                  descriptions.
                </p>
              </div>
            </div>
            <div className="steps-container half-down">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="centered-card"
                  data-aos="flip-left"
                >
                  <div className="centered-card-circle-empty"></div>
                  <div className="centered-card-circle">{step.id}</div>
                  <img src={step.img} alt={step.title} className="step-image" />
                  <h2>{step.title}</h2>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div><div className="linecontainer">
          <div class="lined-heading">
            <h1>Benefits of</h1>
          </div>
          <h2>The Digital Menu Card from Qflyers</h2>
        </div>

        <div className="benefits-container container">
          <div className=" benefit-box">
            <div className="col-lg-6 d-flex flex-column justify-content-between text-box">
              <div className="benefit-image text-center">
                <img
                  src={Images.women}
                  alt="Business Woman"

                />
              </div>
              <div className="benefit-text">
                <h2>For Business</h2>
                <p>
                  The Q-Flyers Digital Menu Card enables real-time updates,
                  eliminating the need for reprints. It adapts quickly to
                  customer demands and inventory changes while providing data
                  insights to track popular items and optimize sales. By
                  analyzing customer behavior, businesses can refine pricing,
                  promotions, and seasonal offers. Additionally, it streamlines
                  ordering, reduces errors, and enhances operational efficiency.
                </p>
              </div>

            </div>

            <div className="col-lg-6 d-flex flex-column justify-content-between text-box">
              <div className="benefit-image text-center">
                <img
                  src={Images.men}
                  alt="Customer Experience"

                />
              </div>
              <div className="benefit-text">
                <h2>For Customer</h2>
                <p>
                  The Digital Menu Card enhances convenience by allowing
                  customers to browse, customize, and order directly from their
                  devices, reducing wait times. Personalized recommendations
                  based on preferences and past orders improve decision-making.
                  It also promotes hygiene by minimizing contact with shared
                  menus, ensuring a safer dining experience.
                </p>
              </div>

            </div>
          </div>
        </div>

        <div className="linecontainer">
          <div class="lined-heading">
            <h1>our Goals</h1>
          </div>
          <p className="goal-content-p"> Enhance your experience and enjoy seamless automation, intelligent
            insights, and effortless management. Discover the difference with
            Qflyers.</p>
        </div>

        <div className="goals-container">
          <div className="container goal-content">


            <div className="goal-container container">
              <div className=" align-items-center goal-grid">
                {/* Left Column - First 3 Images */}
                <div className="col-lg-6">
                  <div className=" goal-grid">

                    <div className="col-lg-6 ">
                      <img
                        src={Images.goal1}
                        className="goal-image big-img"
                        data-aos="flip-left"
                        data-aos-delay="100"
                        alt="Goal 1"
                      />
                    </div>


                    <div className="col-lg-6">
                      <div className="goal-column d-flex flex-column gap-3">
                        <img
                          src={Images.goal2}
                          className="goal-image"
                          data-aos="flip-left"
                          data-aos-delay="200"
                          alt="Goal 2"
                        />
                        <img
                          src={Images.goal3}
                          className="goal-image"
                          data-aos="flip-left"
                          data-aos-delay="300"
                          alt="Goal 3"
                        />
                      </div>
                    </div>
                  </div>

                </div>


                <div className="col-lg-6 d-flex justify-content-center " style={{ marginLeft: "10px" }}>
                  <img
                    src={Images.goal4}
                    className="goal-image"
                    data-aos="flip-left"
                    data-aos-delay="400"
                    alt="Goal 4"
                  />
                </div>
              </div>
            </div>

            {/* <div className="phone-goal-container">

              <img
                src={Images.goal1}

                data-aos="flip-left"
                data-aos-delay="100"
                alt="Goal 1"
              />


              <img
                src={Images.goal2}

                data-aos="flip-left"
                data-aos-delay="200"
                alt="Goal 2"
              />
              <img
                src={Images.goal3}

                data-aos="flip-left"
                data-aos-delay="300"
                alt="Goal 3"
              />


              <img
                src={Images.goal4}

                data-aos="flip-left"
                data-aos-delay="400"
                alt="Goal 4"
              />




            </div> */}
          </div>
        </div>

        <div className="faq-container container">
          <p>Faq’s</p>
          <h1>Got questions?</h1>
          {faqs.map(({ id, question, answer }) => (
            <div key={id} className={`faq-content mt-2 ${openFaq === id ? "active-faq" : ""}`}>
              <div className="faq-number">
                <h1>{id < 10 ? `0${id}` : id}</h1>
              </div>
              <div className="faq-text">
                <h4 onClick={() => toggleFaq(id)} className="faq-header">
                  <span>{question}</span>
                  <span
                    className={`faqicon ${openFaq === id ? "faqcircle" : ""}`}
                  >
                    {openFaq === id ? <X /> : <Plus />}
                  </span>
                </h4>
                <div className={`faq-answer ${openFaq === id ? "open" : ""}`}>{answer}</div>

              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
